export default "__VITE_ASSET__2eed0eda__"